import type { FaireProductEntity } from "../../entity_types/product";

export const p_bxwynnja65: FaireProductEntity = {
  token: "p_bxwynnja65",
  type: "product",
  name: "He Is Risen Long Sleeve Morning Gown",
  brandToken: "b_3jx8e2jgty",
  brandName: "Riley & Rett",
  imageUrl:
    "https://cdn.faire.com/fastly/60a328ba35ad18c6b612cddb10f831c7d33e696351ce9ea67e75ab9976621a11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/347fea2bb19ac3ed31bfb0355788ea5f968d4d08778d16702873fcd6a2f53407.jpeg",
    "https://cdn.faire.com/fastly/34982461b359268759a2c8bed3558f9fc322fd3e856e55bf7cff6e200fa2634b.jpeg",
    "https://cdn.faire.com/fastly/773fb08955be6c480d0037cdefb33fac75c0510cba562d1a503aa812993ed238.jpeg",
    "https://cdn.faire.com/fastly/8a6446384770a6b05c8588deaba2856f147200df52090c67a559b30b19afd571.jpeg",
    "https://cdn.faire.com/fastly/ffaad77b2ed22f2b854ed5e4b06662853ea1819ff23ea292ce3f6c08add84bcd.jpeg",
    "https://cdn.faire.com/fastly/f60fb41db8a7163c4923db2e0c38e8fcecf10a3484ef5c046b28b4007524a7ee.jpeg",
    "https://cdn.faire.com/fastly/482377cfd21b02c37b8bb99a380fd78e146dd4cb95fac8c51c6a1d1f1b6e0a14.jpeg",
  ],
  priceDollars: 19,
  description:
    'Made from the softest bamboo material, Riley + Rett presents our Easter Morning Gown with the perfect mix of comfort and faith. \n\nDesigned to celebrate the resurrection of Jesus Christ, our newest pattern features gorgeous imagery of the three crosses on Calvary and His empty tomb in beautiful pastel shades of yellows, blues, and greens. The joyful phrases "He is Risen" and "Hallelujah" add an extra special connection to the season of renewal. \n\nInspired by the true message of Easter, "He is not here; He has risen," – Matthew 28:6, this collection is perfect for your little ones to celebrate the joy and hope of Easter in comfort, style, and faith.\n',
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:23.303Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
